export function canOrderItem(item, now = Date.now()) {
  if (!item || item.isAvailable !== 1) return false;
  if (item.canOrder === false) return false;
  return !item.availabilityValidUntil || now < Date.parse(item.availabilityValidUntil);
}

export function availabilityText(item) {
  if (item?.isAvailable !== 1) return "Out of stock";
  return item?.availabilityMessage || "Checking availability…";
}

export function scheduleText(schedule) {
  if (!schedule?.slots?.length) return "";
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const time = value => {
    const [hour, minute] = value.split(":").map(Number);
    return `${hour % 12 || 12}${minute ? `:${String(minute).padStart(2, "0")}` : ""} ${hour >= 12 ? "PM" : "AM"}`;
  };
  return schedule.slots.map(slot => {
    const selected = [1, 2, 3, 4, 5, 6, 0].filter(day => slot.days.includes(day));
    const label = selected.length === 7 ? "Available daily:" : `${selected.map(day => days[day]).join(", ")} •`;
    return `${label} ${time(slot.start)}–${time(slot.end)}${slot.end < slot.start ? " (next day)" : ""}`;
  }).join("; ");
}

export function scheduleMessages(item) {
  if (item?.isAvailable !== 1) return [];
  const entries = [
    { label: "Item", schedule: item.availabilitySchedule },
    { label: "Category", schedule: item.categoryAvailabilitySchedule },
  ].filter(entry => entry.schedule?.slots?.length)
    .map(entry => ({ ...entry, text: scheduleText(entry.schedule) }));
  const unique = entries.filter((entry, index) => !entries.slice(0, index).some(previous =>
    previous.text === entry.text && previous.schedule.timeZone === entry.schedule.timeZone));
  return unique.map(entry => ({
    text: unique.length > 1 ? `${entry.label}: ${entry.text}` : entry.text,
    timeZone: entry.schedule.timeZone,
  }));
}
